import { format } from 'date-fns';
import { it } from 'date-fns/locale';

/**
 * Formatta una data nel formato italiano dd/MM/yyyy
 * @param {string|Date} dateString - La data da formattare
 * @returns {string} La data formattata o '-' se non valida
 */
export const formattaData = (dateString) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'dd/MM/yyyy', { locale: it });
  } catch (e) {
    return '-';
  }
};

/**
 * Formatta una data con ora nel formato italiano dd/MM/yyyy HH:mm
 * @param {string|Date} dateString - La data da formattare
 * @returns {string} La data e ora formattata o '-' se non valida
 */
export const formattaDataEdOra = (dateString) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm', { locale: it });
  } catch (e) {
    return '-';
  }
};

/**
 * Formatta solo l'ora nel formato HH:mm
 * @param {string|Date} dateString - La data da cui estrarre l'ora
 * @returns {string} L'ora formattata o '-' se non valida
 */
export const formattaOra = (dateString) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'HH:mm', { locale: it });
  } catch (e) {
    return '-';
  }
};

/**
 * Formatta una data in formato relativo (es: "2 giorni fa")
 * @param {string|Date} dateString - La data da formattare
 * @returns {string} La data relativa o '-' se non valida
 */
export const formattaDataRelativa = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) return 'Oggi';
    if (diffInDays === 1) return 'Ieri';
    if (diffInDays < 7) return `${diffInDays} giorni fa`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} settimane fa`;
    if (diffInDays < 365) return `${Math.floor(diffInDays / 30)} mesi fa`;
    return `${Math.floor(diffInDays / 365)} anni fa`;
  } catch (e) {
    return '-';
  }
};